import { load, ReCaptchaInstance } from "recaptcha-v3";

export default class RecaptchaService {
  private recaptcha: ReCaptchaInstance | null = null;
  private initPromise: Promise<ReCaptchaInstance> | null = null;

  protected siteKey: string;

  constructor(siteKey: string) {
    this.siteKey = siteKey;
  }

  public async init(): Promise<ReCaptchaInstance> {
    if (!this.initPromise) {
      this.initPromise = load(this.siteKey).then((instance) => {
        this.recaptcha = instance;
        return instance;
      });
    }

    return this.initPromise;
  }

  public async getToken(action: string): Promise<string> {
    if (!this.recaptcha) {
      await this.init();
    }

    return this.recaptcha.execute(action);
  }
}
